var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content overflow-hidden"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }